import type { ConditionalFormattingActions } from "./types";

const BLACK = "#262626";
const WHITE = "#FFFFFF";

const PALETTE = [
  { textColor: BLACK, fillColor: WHITE },
  { textColor: "#F5222D", fillColor: "#FFF1F0" },
  { textColor: "#FA8C16", fillColor: "#FFF7E6" },
  { textColor: "#FAAD14", fillColor: "#FFFBE6" },
  { textColor: "#52C41A", fillColor: "#F6FFED" },
  { textColor: "#13C2C2", fillColor: "#E6FFFB" },
  { textColor: "#1677FF", fillColor: "#E6F4FF" }
] as const;

export const FILL_AND_TEXT_PRESETS: ConditionalFormattingActions[] =
  PALETTE.map(({ textColor, fillColor }) => ({
    textColor,
    backgroundColor: fillColor
  }));

export const TEXT_ONLY_PRESETS: ConditionalFormattingActions[] = PALETTE.map(
  ({ textColor }) => ({
    textColor,
    backgroundColor: WHITE
  })
);

export const FILL_ONLY_PRESETS: ConditionalFormattingActions[] = PALETTE.map(
  ({ fillColor }) => ({
    textColor: BLACK,
    backgroundColor: fillColor
  })
);

export const CONDITIONAL_FORMATTING_PRESET_STYLES: ConditionalFormattingActions[] =
  [
    FILL_AND_TEXT_PRESETS[0],
    ...FILL_AND_TEXT_PRESETS.slice(1),
    ...FILL_ONLY_PRESETS.slice(1),
    ...TEXT_ONLY_PRESETS.slice(1)
  ];
